import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export const isPhoneNumber: ValidatorFn =
  Validators.pattern(`^\\+(9[976]\\d|8[987530]\\d|6[987]\\d|5[90]\\d|42\\d|3[875]\\d|
  2[98654321]\\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|
  4[987654310]|3[9643210]|2[70]|7|1)\\d{1,14}$`);

export const phoneNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const regExp =
    '^\\+(9[976]\\d|8[987530]\\d|6[987]\\d|5[90]\\d|42\\d|3[875]\\d|2[98654321]\\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\\d{1,14}$';
  return String(control.value).match(new RegExp(regExp)) || !control.value
    ? null
    : { phoneNumber: true };
};
